import * as PIXI from "pixi.js";
import HowToPlayLayer from "../../layers/HowToPlayLayer";
import HTPFourInARow from "./fourthPart/HTPFourInARow";
import HTPTheWarlock from "./fourthPart/HTPTheWarlockInfo";
import HTPInfoAboutFireworkAnimation from "../../animations/HTPInfoAboutFireworkAnimation";
import HTPClickAnyAnimation from "../../animations/HTPClickAnyAnimation";
import ClickAnyWhereFourth from "./fourthPart/ClickAnyWhereFourthPart";
import { EventBus, EnumEventBus } from "../../managers/EventBus";


export default class HTPFourthPart extends PIXI.Container {
  static instance: HTPFourthPart;
  private HowToPlayLayer = HowToPlayLayer.getInstance();
  private EventBus = EventBus;
  private HTPFourInRowInfo: HTPFourInARow;
  private HTPTheWarlock: HTPTheWarlock;
  private ClickAnyWhere: ClickAnyWhereFourth;
  private isReversed: boolean = false;

  constructor() {
    super();
    if (!HTPFourthPart.instance) {
      HTPFourthPart.instance = this;
    }
    this.HTPFourInRowInfo = new HTPFourInARow();
    this.HTPTheWarlock = new HTPTheWarlock();
    this.ClickAnyWhere = new ClickAnyWhereFourth();

    this.addToCon();
  }

  runAnimations() {
    this.isReversed = false;
    this.ClickAnyWhere.visible = false;
    this.HTPTheWarlock.visible = false;
    this.HTPFourInRowInfo.visible = false;
    this.ClickAnyWhere.scale.set(this.ClickAnyWhere.startScale);
    this.HTPTheWarlock.scale.set(this.HTPTheWarlock.startScale);
    this.HTPFourInRowInfo.scale.set(this.HTPFourInRowInfo.startScale);

    this.EventBus.emit(EnumEventBus.setHFType, "5");
    this.HTPFourInRowInfo.visible = true;
    new HTPInfoAboutFireworkAnimation(this.HTPFourInRowInfo, 1, () => {
      if (this.isReversed) {
        return
      }
      this.HTPTheWarlock.visible = true;
      new HTPInfoAboutFireworkAnimation(this.HTPTheWarlock, 1, () => {
        if (this.isReversed) {
          return
        }
        this.ClickAnyWhere.visible = true;
        new HTPClickAnyAnimation(this.ClickAnyWhere, 1, () => {
        })
      })
    })
  }
  runReverseAnimations(cb: () => void) {
    this.isReversed = true;
    this.ClickAnyWhere.visible = false;
    this.HTPTheWarlock.visible = false;
    this.HTPFourInRowInfo.visible = false;
    cb();
  }
  addToCon() {
    this.HowToPlayLayer.addChild(this);
  }
  static getInstance() {
    return HTPFourthPart.instance;
  }
}